// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":root{--light_text_color:#666}.header-simple{box-shadow:0 1px 0 0 #f1f4f8;background-color:#fff}.header-simple__logo-container{height:50px;display:flex;align-items:center;justify-content:center}.header-simple__logo{display:inline-block}@media (min-width:992px){.header-simple__logo-container{position:relative;height:65px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
